import {useQuery} from '@tanstack/react-query';
import {rqCreateSearchRequest} from '@app/reactQuery/apis/rqHttpsUtils';
import {RQ_GET_DOCTOR_VISIT_REPORT_API, RQ_GET_NEW_DOCTOR_VISIT_REPORT_API} from '@app/reactQuery/apis/constants';

export const RQUseGetDoctorVisitReportData = (payload, options = {}) => {
  return useQuery({
    queryKey:['rq_get_doctor_visit_reports_data', payload],
    queryFn: async ({queryKey, signal}) => {
      const {certificate, locationId, entityTagId, startDate, endDate} = queryKey[1];
      return rqCreateSearchRequest(
        RQ_GET_DOCTOR_VISIT_REPORT_API,
        null,
        certificate,
        {
          locationId: locationId,
          fromYearMonthDate: startDate,
          toYearMonthDate: endDate,
          entityTagId: entityTagId,
        },
        signal,
      );
    },
    ...options,
  });
};

export const RQUseGetNewDoctorVisitReportData = (payload, options = {}) => {
  return useQuery({
    queryKey:['rq_get_new_doctor_visit_reports_data', payload],
    queryFn: async ({queryKey, signal}) => {
      const {certificate, locationId, entityTagId, startDate, endDate} = queryKey[1];
      return rqCreateSearchRequest(
        RQ_GET_NEW_DOCTOR_VISIT_REPORT_API,
        null,
        certificate,
        {
          locationId: locationId,
          fromYearMonthDate: startDate,
          toYearMonthDate: endDate,
          entityTagId: entityTagId,
        },
        signal,
      );
    },
    ...options,
  });
};
